import React, { useState } from 'react';
import CategoryCard from '../components/ui/CategoryCard';
import ProductCard from '../components/ui/ProductCard';
import { SearchIcon, FilterIcon } from 'lucide-react';
const CategoriesPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  // Categories
  const categories = [{
    id: 'fashion',
    name: 'Fashion & Accessories',
    description: 'Discover trendy clothing, jewelry, and accessories from independent designers.',
    image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    productCount: 1245
  }, {
    id: 'home',
    name: 'Home & Living',
    description: 'Beautiful decor, furniture, and home essentials for every space.',
    image: 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    productCount: 876
  }, {
    id: 'electronics',
    name: 'Electronics',
    description: 'The latest gadgets, tech accessories, and electronic innovations.',
    image: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1201&q=80',
    productCount: 543
  }, {
    id: 'handmade',
    name: 'Handmade Crafts',
    description: 'Unique handcrafted items made with care by talented artisans.',
    image: 'https://images.unsplash.com/photo-1452860606245-08befc0ff44b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    productCount: 932
  }, {
    id: 'beauty',
    name: 'Beauty & Personal Care',
    description: 'Natural and organic beauty products for your self-care routine.',
    image: 'https://images.unsplash.com/photo-1571781926291-c477ebfd024b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1376&q=80',
    productCount: 621
  }];
  // Products
  const products = [{
    id: 'prod1',
    name: 'Handcrafted Leather Wallet',
    price: 49.99,
    image: 'https://images.unsplash.com/photo-1627123424574-724758594e93?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    rating: 4.8,
    seller: 'Artisan Leatherworks',
    category: 'fashion',
    isNew: true
  }, {
    id: 'prod2',
    name: 'Minimalist Desk Lamp',
    price: 79.99,
    image: 'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    rating: 4.5,
    seller: 'Modern Home Designs',
    category: 'home',
    discount: 20
  }, {
    id: 'prod3',
    name: 'Organic Cotton T-Shirt',
    price: 29.99,
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80',
    rating: 4.6,
    seller: 'EcoFashion',
    category: 'fashion'
  }, {
    id: 'prod4',
    name: 'Smart Water Bottle',
    price: 45.0,
    image: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    rating: 4.3,
    seller: 'TechLife',
    category: 'electronics',
    isNew: true
  }, {
    id: 'prod5',
    name: 'Handmade Ceramic Mug',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80',
    rating: 4.9,
    seller: 'Pottery Studio',
    category: 'handmade',
    discount: 10
  }, {
    id: 'prod6',
    name: 'Wireless Earbuds',
    price: 89.99,
    image: 'https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80',
    rating: 4.7,
    seller: 'AudioTech',
    category: 'electronics'
  }, {
    id: 'prod7',
    name: 'Natural Face Cream',
    price: 34.5,
    image: 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    rating: 4.4,
    seller: 'Pure Botanicals',
    category: 'beauty',
    discount: 15
  }, {
    id: 'prod8',
    name: 'Vintage Wall Clock',
    price: 59.99,
    image: 'https://images.unsplash.com/photo-1592914610354-fd354ea45e48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80',
    rating: 4.6,
    seller: 'Retro Home',
    category: 'home',
    isNew: true
  }, {
    id: 'prod9',
    name: 'Organic Soap Set',
    price: 28.99,
    image: 'https://images.unsplash.com/photo-1600857544200-b2f666a9a2ec?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1376&q=80',
    rating: 4.8,
    seller: 'Natural Bath Co.',
    category: 'beauty'
  }, {
    id: 'prod10',
    name: 'Handwoven Basket',
    price: 42.0,
    image: 'https://images.unsplash.com/photo-1616486788371-62d930495c44?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1376&q=80',
    rating: 4.9,
    seller: 'Global Artisans',
    category: 'handmade'
  }, {
    id: 'prod11',
    name: 'Portable Bluetooth Speaker',
    price: 69.99,
    image: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1376&q=80',
    rating: 4.2,
    seller: 'SoundMasters',
    category: 'electronics',
    discount: 25
  }, {
    id: 'prod12',
    name: 'Linen Throw Pillow',
    price: 32.5,
    image: 'https://images.unsplash.com/photo-1584360507703-a329e4a75e61?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1376&q=80',
    rating: 4.7,
    seller: 'Comfort Living',
    category: 'home'
  }];
  // Filter products based on active category
  const filteredProducts = activeCategory === 'all' ? products : products.filter(product => product.category === activeCategory);
  return <div className="bg-gray-50 min-h-screen" data-id="element-348">
      {/* Categories Header */}
      <section className="bg-blue-600 text-white py-12" data-id="element-349">
        <div className="container mx-auto px-4" data-id="element-350">
          <h1 className="text-3xl font-bold mb-4" data-id="element-351">Explore Categories</h1>
          <p className="text-xl max-w-2xl" data-id="element-352">
            Discover thousands of unique products across our curated categories
            from verified sellers.
          </p>
        </div>
      </section>
      {/* Search and Filter */}
      <section className="bg-white py-6 shadow-sm" data-id="element-353">
        <div className="container mx-auto px-4" data-id="element-354">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-355">
            <div className="relative w-full md:w-96" data-id="element-356">
              <input type="text" placeholder="Search products..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full" data-id="element-357" />
              <SearchIcon className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-358" />
            </div>
            <button className="flex items-center space-x-2 text-gray-600 hover:text-blue-600" data-id="element-359">
              <FilterIcon className="h-5 w-5" data-id="element-360" />
              <span data-id="element-361">Filter</span>
            </button>
          </div>
        </div>
      </section>
      {/* Categories */}
      <section className="py-12" data-id="element-362">
        <div className="container mx-auto px-4" data-id="element-363">
          <h2 className="text-2xl font-bold mb-6" data-id="element-364">Browse Categories</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-365">
            {categories.map(category => <CategoryCard key={category.id} id={category.id} name={category.name} description={category.description} image={category.image} productCount={category.productCount} data-id="element-366" />)}
          </div>
        </div>
      </section>
      {/* Category Tabs */}
      <section className="py-8 bg-white" data-id="element-367">
        <div className="container mx-auto px-4" data-id="element-368">
          <div className="flex flex-wrap gap-2 border-b border-gray-200" data-id="element-369">
            <button className={`px-4 py-2 font-medium text-sm transition-colors duration-200 ${activeCategory === 'all' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:text-blue-600'}`} onClick={() => setActiveCategory('all')} data-id="element-370">
              All Products
            </button>
            {categories.map(category => <button key={category.id} className={`px-4 py-2 font-medium text-sm transition-colors duration-200 ${activeCategory === category.id ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:text-blue-600'}`} onClick={() => setActiveCategory(category.id)} data-id="element-371">
                {category.name}
              </button>)}
          </div>
        </div>
      </section>
      {/* Products */}
      <section className="py-12" data-id="element-372">
        <div className="container mx-auto px-4" data-id="element-373">
          <div className="flex justify-between items-center mb-6" data-id="element-374">
            <h2 className="text-2xl font-bold" data-id="element-375">
              {activeCategory === 'all' ? 'All Products' : categories.find(cat => cat.id === activeCategory)?.name}
            </h2>
            <div className="flex items-center" data-id="element-376">
              <span className="text-gray-600 text-sm mr-2" data-id="element-377">Sort by:</span>
              <select className="border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-378">
                <option data-id="element-379">Featured</option>
                <option data-id="element-380">Price: Low to High</option>
                <option data-id="element-381">Price: High to Low</option>
                <option data-id="element-382">Customer Rating</option>
                <option data-id="element-383">Newest</option>
              </select>
            </div>
          </div>
          {filteredProducts.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-384">
              {filteredProducts.map(product => <ProductCard key={product.id} id={product.id} name={product.name} price={product.price} image={product.image} rating={product.rating} seller={product.seller} discount={product.discount} isNew={product.isNew} data-id="element-385" />)}
            </div> : <div className="text-center py-12" data-id="element-386">
              <p className="text-gray-600" data-id="element-387">
                No products found in this category.
              </p>
            </div>}
          {/* Pagination */}
          <div className="flex justify-center mt-10" data-id="element-388">
            <div className="flex space-x-1" data-id="element-389">
              <button className="px-3 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-100" data-id="element-390">
                &laquo;
              </button>
              <button className="px-3 py-1 rounded border border-blue-600 bg-blue-600 text-white" data-id="element-391">
                1
              </button>
              <button className="px-3 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-100" data-id="element-392">
                2
              </button>
              <button className="px-3 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-100" data-id="element-393">
                3
              </button>
              <button className="px-3 py-1 rounded border border-gray-300 text-gray-600 hover:bg-gray-100" data-id="element-394">
                &raquo;
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default CategoriesPage;